import Heatmap from "../Heatmap/Heatmap";
import { useTheme } from "../../theme/useTheme";
import Scattergraph from "../Scattergraph/Scattergraph";
import { scrnaseqapi, parseMarkdownLinks } from "../../utils/utils";
import { GeneTherapeuticHeader } from "../Header/GeneTherapeuticHeader";

const ExpressionSummaries = (props: any) => {
  const { tabdata, scrnaseqdata, setScrnaseqdata, setLoading } = useTheme();

  const rnaseqDatasetup = async (value: string) => {
    setLoading(true);
    try {
      const currobj = Object.keys(tabdata.rnaseqdatasets.data)
        .filter((key) => key === value)
        .reduce((obj: any, key: any) => {
          obj[key] = tabdata.rnaseqdatasets.data[key];
          return obj[key];
        }, {});
      await scrnaseqapi(
        currobj,
        props.therapeuticAreaInternal,
        props.selectedgene,
        setScrnaseqdata,
      );
    } catch (error) {
      console.error("Error fetching RNA-seq data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <GeneTherapeuticHeader
        selectedGene={props.selectedgene}
        therapeuticArea={props.therapeuticArea ?? undefined}
        taxonomyNodes={props.taxonomyNodes}
        selectedDiseaseIds={props.selectedDiseaseIds}
        onDiseaseSelectionChange={props.onDiseaseSelectionChange}
      />
      <div className="">
        {props.selectedgene ? (
          <div className="space-y-4">
            {tabdata?.geneinfo?.data?.length > 0 ? (
              <div className="grid grid-cols-2 gap-4 mt-5">
                {/*   SCATTER CHART PANEL   */}
                <div className="bg-white dark:bg-gray-900 rounded-xl shadow-md py-4 px-4 flex flex-col dark:border-gray-600">
                  <h4 className="text-lg font-bold mb-2 text-gray-900 dark:text-gray-100">
                    Gene Tissue Expression
                  </h4>
                  <p className="text-gray-700 dark:text-gray-300">
                    GTEx gene tissue expression in Heart-relevant tissues and
                    other tissues. The tissue with the highest expression level
                    other than Heart is highlighted.
                  </p>
                  <div className="relative w-full h-[400px] mt-4">
                    <Scattergraph
                      title="Gene Tissue Expression"
                      name="Disease"
                      xaxislabel="Tissue"
                      yaxislabel="Normalized expression"
                      data={tabdata.tissueexpression.data}
                    />
                  </div>
                </div>
                {/*   HEAT MAP PANEL        */}
                <div className="bg-white dark:bg-gray-900 rounded-xl shadow-md py-4 px-4 flex flex-col dark:border-gray-600">
                  <h4 className="text-lg font-bold mb-2 text-gray-900 dark:text-gray-100">
                    Single Cell RNA-seq Data
                  </h4>
                  <select
                    id="rnaseqData"
                    value={scrnaseqdata.name}
                    onChange={(e) => rnaseqDatasetup(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 my-2"
                  >
                    {Object.keys(tabdata.rnaseqdatasets.data).map(
                      (keyName: any, keyIndex: any) => {
                        return (
                          <option
                            key={`optname_${keyIndex}`}
                            selected={keyName === scrnaseqdata.name}
                          >
                            {keyName}
                          </option>
                        );
                      },
                    )}
                  </select>

                  <p className="text-gray-700 dark:text-gray-300">
                    {parseMarkdownLinks(scrnaseqdata.description)}
                  </p>
                  <div className="mt-4">
                    <Heatmap
                      title={`${scrnaseqdata.name} Dataset Expression`}
                      xaxisvalues={scrnaseqdata.xvalues}
                      yaxisvalues={scrnaseqdata.yvalues}
                      zaxisvalues={scrnaseqdata.zvalues}
                      rowNames={scrnaseqdata.rowNames}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-8 text-red-500">
                <p className="text-sm font-medium">
                  No knwoledge Graph Association Data found for{" "}
                  {props.selectedgene}. Try another disease name, check
                  spelling, or broaden your search.
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500 dark:text-gray-400">
            <div className="text-6xl mb-4">🧬</div>
            <p className="text-gray-600 dark:text-gray-400">
              Enter a gene symbol to view detailed information
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpressionSummaries;
